import React, { useState, useEffect, useRef } from 'react'
import { useForm, Controller } from 'react-hook-form'
import Widget from '../../../dpe-usco/components/Widget/Widget'
import Select from '../../../dpe-usco/components/Select/Select'
import _ from 'lodash'

const listOfStates = [
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'WA',
  'WV',
  'WI',
  'WY'
]

const canadaStates = [
  'Alberta','British Columbia','Manitoba','New Brunswick','Newfoundland and Labrador',
  'Northwest Territories','Nova Scotia','Nunavut','Ontario','Prince Edward Island',
  'Quebec','Saskatchewan','Yukon'
]

const pStyle = 'tal p0 ml10 mt0 mb0 fz15'

const DeliveryLocationWidget = ({ returnData, deliveryLocationData }) => {
  const { control, handleSubmit, register, watch, setValue } = useForm()
  const watchAllInputs = watch()

  const [permitUpdate, setPermitUpdate] = useState(true)
  const onSubmit = values => {
    returnData({ type: 'UPDATE_DELIVERY_LOCATION', payload: values })
  }
  const handleSelectState = state => {
    setValue('state', state)
  }

  const prevAllInputs = useRef()

  useEffect(() => {
    if (deliveryLocationData) {
      setPermitUpdate(false)
      const {
        location_name,
        location_address1,
        location_address2,
        location_city,
        location_state,
        location_zipcode,
        location_country
      } = deliveryLocationData
      setValue([
        { location_name },
        { location_address1 },
        { location_address2 },
        { location_city },
        { location_state },
        { location_zipcode },
        { location_country }
      ])
    }
  }, [deliveryLocationData, setPermitUpdate, setValue])

  useEffect(() => {
    if (prevAllInputs.current) {
      if (permitUpdate) {
        if (!_.isEqual(prevAllInputs.current, watchAllInputs)) {
          const newObj = { ...watchAllInputs }
          newObj.location_country = deliveryLocationData?deliveryLocationData.location_country:'USA'
          if (!newObj.location_country) {
            delete newObj.location_address2
          }
          returnData({ type: 'UPDATE_DELIVERY_LOCATION', payload: newObj })
          prevAllInputs.current = watchAllInputs
        }
      } else {
        setPermitUpdate(true)
      }
    } else {
      prevAllInputs.current = watchAllInputs
    }
  }, [watchAllInputs, setPermitUpdate, permitUpdate, returnData, deliveryLocationData])
  return (
    <Widget title="Delivery location">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="mb20 w45%">
          <div className="df mb10">Delivery location name*</div>
          <input
            name="location_name"
            aria-label="location_name"
            ref={register()}
          />
        </div>
        <div className="mb20 w45%">
          <div className="df mb10">Delivery address*</div>
          <input
            name="location_address1"
            aria-label="location_address1"
            ref={register()}
          />
        </div>
        <div className="mb20 w45%">
          <div className="df mb10">Unit #</div>
          <input
            name="location_address2"
            aria-label="location_address2"
            ref={register()}
          />
        </div>
        <div className="mb20 df jcsb">
          <div className="w45%">
            <div className="df mb10">City*</div>
            <input
              name="location_city"
              aria-label="location_city"
              ref={register()}
            />
          </div>
          <div className="w45% df">
            <div className="df fxdrc w45% mr16">
              <label className="df mb10">State*</label>
              <Controller
                as={<Select defaultValue={watchAllInputs.location_state} />}
                placeholder="Select a state"
                handleSelection={handleSelectState}
                options={deliveryLocationData?.location_country === 'USA' ? listOfStates:canadaStates}
                control={control}
                name="location_state"
                aria-label="location_state"
              />
            </div>
            <div className="df fxdrc w45%">
              <label className="df mb10">Zip code*</label>
              <input
                name="location_zipcode"
                aria-label="location_zipcode"
                ref={register()}
              />
            </div>
          </div>
        </div>
        <div className="mb20 w45%">
          <div className="df mb10">Country</div>
          <p className={pStyle}>
            {deliveryLocationData?.location_country || 'USA'}
          </p>
        </div>
      </form>
    </Widget>
  )
}

export default DeliveryLocationWidget
